import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ExternalIntegration } from "types/generated";

const ServiceNowTableNameCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./${integration.id}`}>{integration.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default ServiceNowTableNameCell;
